import * as React from 'react';

import { IconProps } from './Icon';

export const ShippingOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    viewBox="0 0 32 32"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_1">
      <g fill="rgb(0,0,0)">
        <path d="m27.2422 4.8608h-4.988c-.0015 0-.0027-.0009-.0042-.0009h-5.21c-.0015 0-.0027.0009-.0042.0009h-11.362c-.5522 0-1 .4478-1 1s.4478 1 1 1h10.3662v6.0192c0 .55.45 1 1 1h5.21c.55 0 1-.45 1-1v-6.0192h3.9922c.6772 0 1.228.5508 1.228 1.228v15.8223c0 .6772-.5508 1.228-1.228 1.228h-15.8223c-.6768 0-1.2275-.5508-1.2275-1.228v-10.9922c0-.5522-.4478-1-1-1h-2.644c-.5522 0-1 .4478-1 1s.4478 1 1 1h1.644v9.9922c0 1.7798 1.4478 3.228 3.2275 3.228h15.8223c1.7798 0 3.228-1.4482 3.228-3.228v-15.8222c0-1.7798-1.4482-3.2281-3.228-3.2281zm-5.9922 7.0192h-3.21v-5.0192h3.21z" />
        <path d="m2.5298 10.3887h6.1704c.5522 0 1-.4478 1-1s-.4478-1-1-1h-6.1704c-.5522 0-1 .4478-1 1s.4477 1 1 1z" />
        <path d="m25.3687 23.2456c.5522 0 1-.4478 1-1s-.4478-1-1-1h-3.123c-.5522 0-1 .4478-1 1s.4478 1 1 1z" />
      </g>
    </g>
  </svg>
);
